import styled from "styled-components";
import PageTemplate from "../component/PageTemplate.tsx";
import ImgBanner from "../assets/img/introduction/banner.png";
import ImgContent01 from "../assets/img/introduction/history/content01.png";

import ImgMoContent01 from "../assets/img/introduction/history/mo_content01.png";
import { useContext } from "react";
import { WrapperContext } from "../component/WrapperContext.tsx";

const Main = styled.div`
    width: 100%;
    height: 100%;
    text-align: left;
    padding: ${(props) => (!props.isMobile ? "25px 0 0 10px" : "25px 0 0 0")};
`;

const Content = styled.img`
    width: 100%;
    margin-bottom: 10vh;
`;

export default function History() {
    const { isMobile } = useContext(WrapperContext);

    return (
        <PageTemplate bannerImage={ImgBanner}>
            <Main isMobile={isMobile}>{!isMobile ? <Content src={ImgContent01} /> : <Content src={ImgMoContent01} />}</Main>
        </PageTemplate>
    );
}
